import { useRef } from 'react';
import { useToast } from '@givebutter/primitives/toast';
import { AccountMediaType, uploadAccountMedia } from 'api/media';
import axios from 'axios';
import { Upload, UploadRef } from 'components/upload';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useInvalidateUserAndAccount } from 'customHooks/useInvalidateUserAndAccount';

interface LogoUploadProps {
    type: AccountMediaType;
    defaultUrl?: string;
}

const LogoUpload = ({ type, defaultUrl }: LogoUploadProps) => {
    const toast = useToast();
    const { mutate: invalidateUserData } = useInvalidateUserAndAccount();
    const { accountId } = useCurrentAccount();
    const ref = useRef<UploadRef>(null);

    return (
        <Upload
            ref={ref}
            variant="single"
            imagePreviewHeight={250}
            defaultFiles={defaultUrl ? [{ id: `logo-${type}`, url: defaultUrl }] : []}
            acceptedFileTypes={['image/*']}
            allowReorder={false}
            allowMultiple={false}
            allowReplace={true}
            //@ts-ignore
            allowRemove={false}
            strategy="remote"
            onactivatefile={() => {
                ref.current?.browse();
            }}
            onUpload={() => {
                toast.success(
                    `Uploaded ${transformAccountMediaTypeToReadable(type)} photo successfully!`,
                );
                invalidateUserData();
            }}
            onUploadError={e => {
                if (axios.isAxiosError(e)) {
                    toast.error(e.response?.data.message ?? 'Failed to upload photo');
                }
            }}
            uploadFn={async file => {
                const { data } = await uploadAccountMedia(accountId, file, 'logos', type);

                return data.url;
            }}
        />
    );
};

const transformAccountMediaTypeToReadable = (type: AccountMediaType) => {
    switch (type) {
        case 'default':
            return 'main';
        case 'email':
            return 'email';
    }
};

export { LogoUpload };
